import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { SmoothScroll } from "@/components/layout/SmoothScroll";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import Laws from "@/pages/Laws";
import LawDetail from "@/pages/LawDetail";
import DailyLife from "@/pages/DailyLife";
import FAQ from "@/pages/FAQ";
import Resources from "@/pages/Resources";
import Study from "@/pages/Study";
import SourceSheet from "@/pages/SourceSheet";
import Essay from "@/pages/Essay";
import Moshiach from "@/pages/Moshiach";
import Card from "@/pages/Card";
import NotFound from "@/pages/NotFound";

const AnimatedRoutes = () => {
  const location = useLocation();
  if (location.pathname === "/card") return <Card />;
  return (
    <>
      <Navbar />
      <AnimatePresence mode="wait" initial={false}>
      <motion.main
        key={location.pathname}
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -8 }}
        transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
      >
        <Routes location={location}>
          <Route path="/" element={<Laws />} />
          <Route path="/laws" element={<Navigate to="/" replace />} />
          <Route path="/laws/:slug" element={<LawDetail />} />
          <Route path="/daily-life" element={<DailyLife />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/study" element={<Study />} />
          <Route path="/study/sources/:id" element={<SourceSheet />} />
          <Route path="/study/essays/:slug" element={<Essay />} />
          <Route path="/moshiach" element={<Moshiach />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </motion.main>
    </AnimatePresence>
      <Footer />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <div className="grain min-h-screen bg-parchment text-ink">
          <AnimatedRoutes />
        </div>
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
